import {marketRepository} from '@/repositories/Index';


class MarketService {
    // cpt钱包可用余额
    async getCptWalletInfoFn() {
      const res = await marketRepository.getCptWalletInfo();
      return res;
    }
    


    //精准营销-产品申购页关联关系
    async createOrderCheckFn(params: any) {
        const res = await marketRepository.createOrderCheck(params);
        return res;
    }

    //精准营销-创建
    async createOrderFn(params: any) {
        const res = await marketRepository.createOrder(params);
        return res;
    }

    //精准营销-订单列表
    async getOrderListFn(params: any) {
        const res = await marketRepository.getOrderList(params);
        return res;
    }

    //精准营销-结束活动
    async updateMarketOrderFn(params: any) {
        const res = await marketRepository.updateMarketOrder(params);
        return res;
    }

    //精准营销-订单操作记录
    async getSmsMarketOrderLogsFn(params: any) {
        const res = await marketRepository.getSmsMarketOrderLogs(params);
        return res;
    }


    //精准营销-订单详情
    async getOrderDetailFn(params: any) {
        const res = await marketRepository.getOrderDetail(params);
        return res;
    }
    
    //精准营销活动id
    async getActivityIdsFn() {
        const res = await marketRepository.getActivityIds();
        return res;
    }


    //精准营销-营销数据概览
    async getSmsMarketDataOverviewFn(params: any) {
        const res = await marketRepository.getSmsMarketDataOverview(params);
        return res;
    }

    //精准营销-营销折线图数据
    async getSmsMarketLineChartDataFn(params: any) {
        const res = await marketRepository.getSmsMarketLineChartData(params);
        return res;
    }

    //CPT钱包支付
    async cptAccountBalanceFn(params: any) {
        const res = await marketRepository.cptAccountBalance(params);
        return res;
    }
  }
  
  export default MarketService;
  